import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Auxiliares';

export interface Auxiliar {
  vehiculo: string;
  auxiliar: string;
}

export class AuxiliaresAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarAuxiliares(): AxiosPromise<Auxiliar[]> {
		return this.cliente.get(`/ListarAuxiliares`);
	}

	CrearAuxiliar(auxiliar:Auxiliar): AxiosPromise<Auxiliar[]> {
		return this.cliente.post(auxiliar, `/CrearAuxiliar`);
	}
	
	EliminarAuxiliar(auxiliar:Auxiliar): AxiosPromise<any> {
		return this.cliente.removeVarious(auxiliar.vehiculo, auxiliar.auxiliar, `/EliminarAuxiliar`);
	}

	ModificarAuxiliar(updateData: any): AxiosPromise<any[]> {
		return this.cliente.put('', updateData,`/ModificarAuxiliar`);
	}
}